/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from "../ApiClient";
import TenantSmsMessage from '../model/TenantSmsMessage';
import TwilioMessagesBody from '../model/TwilioMessagesBody';

/**
* TwilioMessages service.
* @module api/TwilioMessagesApi
* @version v0.3
*/
export default class TwilioMessagesApi {

    /**
    * Constructs a new TwilioMessagesApi. 
    * @alias module:api/TwilioMessagesApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instanc
    e} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }

    /**
     * Callback function to receive the result of the twilioMessagesGet operation.
     * @callback moduleapi/TwilioMessagesApi~twilioMessagesGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Twilio SMS messages for patients
     * @param {String} userId User ID
     * @param {module:api/TwilioMessagesApi~twilioMessagesGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    twilioMessagesGet(userId, callback) {
      
      let postBody = null;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling twilioMessagesGet");
      }

      let pathParams = {
        
      };
      let queryParams = {
        'user_id': userId
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/twilio_messages', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the twilioMessagesNewMessagesForTenantGet operation.
     * @callback moduleapi/TwilioMessagesApi~twilioMessagesNewMessagesForTenantGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/TenantSmsMessage>{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * New messages for tenant
     * @param {module:api/TwilioMessagesApi~twilioMessagesNewMessagesForTenantGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    twilioMessagesNewMessagesForTenantGet(callback) {
      
      let postBody = null;

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [TenantSmsMessage];

      return this.apiClient.callApi(
        '/twilio_messages/new_messages_for_tenant', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the twilioMessagesPost operation.
     * @callback moduleapi/TwilioMessagesApi~twilioMessagesPostCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Send a Twilio SMS text message
     * &lt;h3&gt;   &amp;#128275; Access policy &lt;/h3&gt; &lt;p&gt;You can access this endpoint with the following token types:&lt;/p&gt; &lt;p&gt;&amp;#9989; M2M&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;#10060; &lt;s&gt;Patient&lt;/s&gt;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;#9989; Practitioner&lt;/p&gt; 
     * @param {String} userId User ID
     * @param {Object} opts Optional parameters
     * @param {module:model/TwilioMessagesBody} opts.body 
     * @param {module:api/TwilioMessagesApi~twilioMessagesPostCallback} callback The callback function, accepting three arguments: error, data, response
     */
    twilioMessagesPost(userId, opts, callback) {
      opts = opts || {};
      let postBody = opts['body'];
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling twilioMessagesPost");
      }

      let pathParams = {
        
      };
      let queryParams = {
        'user_id': userId
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/twilio_messages', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the twilioMessagesSendSmsReminderMessagePost operation.
     * @callback moduleapi/TwilioMessagesApi~twilioMessagesSendSmsReminderMessagePostCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Send SMS reminder message for in-app message
     * &lt;h3&gt;   &amp;#128275; Access policy &lt;/h3&gt; &lt;p&gt;You can access this endpoint with the following token types:&lt;/p&gt; &lt;p&gt;&amp;#9989; M2M&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;#10060; &lt;s&gt;Patient&lt;/s&gt;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;#9989; Practitioner&lt;/p&gt; 
     * @param {String} userId User ID
     * @param {module:api/TwilioMessagesApi~twilioMessagesSendSmsReminderMessagePostCallback} callback The callback function, accepting three arguments: error, data, response
     */
    twilioMessagesSendSmsReminderMessagePost(userId, callback) {
      
      let postBody = null;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling twilioMessagesSendSmsReminderMessagePost");
      }

      let pathParams = {
        
      };
      let queryParams = {
        'user_id': userId
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/twilio_messages/send_sms_reminder_message', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

}